import { useTranslation } from 'react-i18next';
import useConfigurationStore from '../store/configurationStore';

export default function StepNavigation() {
    const { t } = useTranslation();
    const { categories, currentStep, setStep } = useConfigurationStore();

    const steps = [
        { id: 'project-info', name: 'Projectinformatie', icon: 'dashicons-info' },
        ...categories.map((cat) => ({ id: cat.id, name: cat.name, icon: cat.icon })),
        { id: 'summary', name: t('wizard.summary'), icon: 'dashicons-clipboard' },
    ];

    return (
        <nav className="ast-step-nav">
            {steps.map((step, index) => (
                <button
                    key={step.id}
                    className={`ast-step-nav__item ${index === currentStep ? 'ast-step-nav__item--active' : ''} ${index < currentStep ? 'ast-step-nav__item--done' : ''}`}
                    onClick={() => setStep(index)}
                >
                    <span className="ast-step-nav__number">{index + 1}</span>
                    <span className="ast-step-nav__label">{step.name}</span>
                </button>
            ))}
        </nav>
    );
}
